import { useMemo } from 'react'

// Environment → manage-merchants host, read off the LMS's own hostname the way useMonolithBaseUrl is.
export const useManageMerchantsBaseUrl = () => {
  return useMemo(() => {
    const hostname = window.location.hostname
    if (hostname.includes('localhost') || hostname.includes('dev')) {
      return 'https://manage-merchants.dev-icebergfinance.ca'
    }
    if (hostname.includes('uat')) {
      return 'https://manage-merchants.uat-icebergfinance.ca'
    }
    if (hostname.includes('int')) {
      return 'https://manage-merchants.int-icebergfinance.ca'
    }
    return 'https://manage-merchants.icebergfinance.ca' // prod fallback
  }, [])
}
